/**
 * ReplaysSlider.js — 4-up swipeable slider with a 25% peek of the next slide, no arrows or dots
 */
import Swiper from 'swiper';

export default class ReplaysSlider { 
  constructor(selector = '.Replays-slider') {
    this.el = document.querySelector(selector);
    if (!this.el) return;

    this.swiper = new Swiper(this.el, {
      slidesPerView: 3.25,
      spaceBetween: 20,
    });
  }
}

